/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { ApolloError, gql, useMutation } from "@apollo/client";

import { useErrorsOrSuccessHandler } from "graphql/errorHandlers";
import { ACCOUNT_FRAGMENT, AccountFragment } from "graphql/fragments";
import { DestroyAccountSymbolInput } from "graphql/types";

const DESTROY_ACCOUNT_SYMBOL = gql`
  mutation ($input: DestroyAccountSymbolInput!) {
    destroyAccountSymbol(input: $input) {
      account {
        ...AccountFragment
      }
    }
  }
  ${ACCOUNT_FRAGMENT}
`;

interface Payload {
  account?: AccountFragment | null;
}

interface DestroyAccountSymbolMutation {
  destroyAccountSymbol: Payload | null;
}

export const useDestroyAccountSymbolMutation = () => {
  const handleErrors = useErrorsOrSuccessHandler();

  const [mutation, { data, loading }] = useMutation<
    DestroyAccountSymbolMutation,
    { input: DestroyAccountSymbolInput }
  >(DESTROY_ACCOUNT_SYMBOL);

  const destroyAccountSymbol = (
    input: DestroyAccountSymbolInput = {},
    onSuccess?: (account: AccountFragment) => void
  ) =>
    mutation({ variables: { input } })
      .then(({ data, errors }) => {
        const account = data?.destroyAccountSymbol?.account;

        handleErrors({
          dataErrors: [],
          graphqlErrors: errors,
          onSuccess: () => onSuccess && account && onSuccess(account),
        });
      })
      .catch((_error: ApolloError) => null);

  return {
    destroyAccountSymbol,
    isLoading: loading,
    account: data?.destroyAccountSymbol?.account,
  };
};
